<template>
  <div class="financial-reconciliation">
    <div class="search">
      <el-select
        class="white selectDate"
        v-model="search.select"
        placeholder="请选择"
        @change="changeDateType"
      >
        <el-option
          v-for="item in selectDateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="white w200"
        v-if="search.select === 1"
        v-model="search.date"
        type="date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-date-picker
        class="white w200"
        v-if="search.select === 2"
        v-model="search.month"
        type="month"
        format="yyyy-MM"
        value-format="yyyy-MM"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-select
        class="white w200"
        v-model="search.customer"
        filterable
        clearable
        placeholder="请选择客户"
      >
        <el-option
          v-for="item in customerList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select class="white w200" clearable v-model="search.warehouseId" placeholder="请选择仓库">
        <el-option
          v-for="item in warehouseList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="search.projectName"
        class="white w200"
        placeholder="请输入项目名称"
      ></el-input>
      <el-button class="btn-blue" @click="searchList">搜索</el-button>
    <el-button
      class="btn-blue"
      @click="exportMonthBillForm"
      >导出</el-button>
    <el-button
      class="btn-white"
      @click="billRecalculation"
      >账单重算</el-button>
    </div>
    <div class="table">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="creatTime" label="日期"></el-table-column>
        <el-table-column prop="name" label="客户名称"></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="statusVal" label="账单状态"></el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="btn-text" @click="look(scope.row.id)"
              >查看</el-button
            >
            <el-button v-if="scope.row.status === 2" type="text" class="btn-text" @click="send(scope.row.id)"
              >发送</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-button
          class="btn-blue"
          @click="batchVerification"
        >核实</el-button>
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    <!-- 账单重算 -->
    <el-dialog title="账单重算" top="15vh" :visible.sync="billRecalculationDialog" width="420px">
      <div class="border"></div>
      <el-form
        ref="billRecalculationForm"
        :model="billRecalculationForm"
        label-width="80px"
      >
        <el-form-item label="仓库：" prop="freightRecalculation">
          <el-select
            class="white w200"
            clearable
            v-model="billRecalculationForm.warehouseId"
            placeholder="请选择仓库"
            @change="changeWarehouse"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目：" prop="projectId">
          <el-select
            v-model="billRecalculationForm.projectId"
            class="gray"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型：">
          <el-select
            class="white selectDate"
            v-model="billRecalculationForm.select"
            placeholder="请选择"
          >
            <el-option
              v-for="item in selectDateTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间：">
          <el-date-picker
            class="white"
            v-if="billRecalculationForm.select === 1"
            v-model="billRecalculationForm.date"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-date-picker
            class="white"
            v-if="billRecalculationForm.select === 2"
            v-model="billRecalculationForm.date"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="运费重算：" prop="freightRecalculation">
          <el-select
            v-model="billRecalculationForm.freightRecalculation"
            class="gray"
            placeholder="请选择"
          >
            <el-option
              v-for="item in freightRecalculationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="telephone">
          <el-input
            v-model="billRecalculationForm.telephone"
            class="white"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submit('billRecalculationForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Logistics from "models/logistics";
const logistics = new Logistics();
import Financial from "models/financial";
import Expenses from "models/expenses";
const expenses = new Expenses();
import PersonnelPay from "models/personnel-pay";
const personnelPay = new PersonnelPay();
const STATUS = {1:'待核实',2:'待发送',3:'待确认',4:'已确认'}
export default {
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      search: {
        select: 1,
        date: "",
        month: "",
        customer: "",
        projectName: "",
        warehouseId: ""
      },
      warehouseList: [],
      customerList: [],
      tableData: [],
      selectDateList: [
        { label: "日账单", value: 1 },
        { label: "月账单", value: 2 },
      ],
      billIdList: [],
      billRecalculationForm: {
        warehouseId: '',
        projectId: '',
        freightRecalculation: 0,
        select: 1,
        date: ''
      },
      freightRecalculationList: [
        {id:1, name: '是'},
        {id:0, name: '否'},
      ],
      billRecalculationDialog: false,
      projectList: [],
      selectDateTypeList: [
        {id:1, name: '日'},
        {id:2, name: '月'},
      ]
    };
  },
  components: {
    PaginationTpl,
  },

  created() {
    this.getCustomerList();
    this.getWarehouse();
    this.initFinancicalReconciliationList();
  },

  methods: {
    //获取名项目数据
    getprojectList() {
      let warehouseId = this.billRecalculationForm.warehouseId
      personnelPay.getProjectListByWarehouse(warehouseId).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          this.projectList = arr;
        }
      });
    },
    changeWarehouse() {
      this.getprojectList()
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    /* 翻页 */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initFinancicalReconciliationList();
    },
    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    searchList() {
      this.currentPage = 1
      this.initFinancicalReconciliationList();
    },
    initFinancicalReconciliationList() {
      let pageNo = this.currentPage
      let type = this.search.select
      let billDate
      if (type === 1) {
        billDate = this.search.date ? this.search.date : ''
      } else {
        billDate = this.search.month ? this.search.month : ''
      }
      let customerId = this.search.customer
      let projectName = this.search.projectName
      let warehouseId = this.search.warehouseId
      Financial.getFinancial(type, pageNo, billDate, customerId, projectName, warehouseId).then(res => {
      if (res.success) {
          this.pageSize = res.result.pageSize;
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.customerName;
            obj.creatTime = value.billDate;
            obj.amount = value.totalAmount;
            obj.projectName = value.projectName;
            obj.projectId = value.projectId;
            obj.type = value.type;
            obj.status = value.status;
            obj.statusVal = STATUS[value.status];
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    look(id) {
      this.$router.push({
        path: "/finance/financial-reconciliation/bill-details",
        query: {
          id
        }
      })
    },
    send(id) { 
      this.$confirm("账单是否确认发送？", "发送", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      }).then(() => {
        let data = {
          id: id
        }
        Financial.postSend(data).then(res => {
          if (res.success) {
            this.initFinancicalReconciliationList();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    /* 导出账单 */
    exportMonthBillForm() {
      let data = {
        billIdList: this.billIdList
      }
      if (this.billIdList.length === 0) {
        this.$message.error('请选择账单')
        return
      }
      Financial.getExport(data, this.search.select).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    /* 所选中的商品数据 */
    handleSelectionChange(val) {
      let arr = []
      val.map(i => {
        arr.push(i.id)
      })
      this.billIdList = arr
    },
    changeDateType(v) {
      this.search.select = v
      this.searchList()
    },
    /* 批量核实 */
    batchVerification() {
      if (this.billIdList.length == 0) {
        this.$message.error('请先选择账单');
        return
      }
      let billIds = this.billIdList
      let data = {
        billIds
      }
      Financial.postBatchVerification(data).then(res => {
        if (res.success) {
          this.initFinancicalReconciliationList();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 账单重算 */
    billRecalculation() {
      this.billRecalculationDialog = true
    },
    closeDialog() {
      this.billRecalculationForm = {
        warehouseId: '',
        projectId: '',
        freightRecalculation: 0,
        select: 1,
        date: '',
        telephone: ''
      },
      this.billRecalculationDialog = false
    },
    submit() {
      let warehouseId = this.billRecalculationForm.warehouseId
      let projectId = this.billRecalculationForm.projectId ? this.billRecalculationForm.projectId : 0
      let type = this.billRecalculationForm.select
      let date = this.billRecalculationForm.date
      let repeatCalExpress = this.billRecalculationForm.freightRecalculation == 1?true:false
      let telephone = this.billRecalculationForm.telephone
      let data = {
        warehouseId,
        projectId,
        type,
        date,
        repeatCalExpress,
        telephone
      }
      Financial.postBillRecalculation(data).then(res => {
        if (res.success) {
          this.initFinancicalReconciliationList();
          this.closeDialog()
        } else {
          this.$message.error(res.message);
        }
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.financial-reconciliation {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .search {
    padding: 16px;
    background: #fff;
    display: flex;
    border-radius: 4px;
    margin-bottom: 16px;
    .el-button {
      margin-left: 16px;
    }
    .w200 {
      width: 200px;
      margin-right: 16px;
    }
  }
  .table {
    height: 100%;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }
  .el-select {
    width: 100%;
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
  }
}
</style>
<style lang="scss">
.financial-reconciliation {
  .search {
    .selectDate {
      width: 85px;
      .el-input__inner {
        border-right: none;
        border-radius: 4px 0px 0px 4px;
      }
    }
    .el-date-editor {
      .el-select.white .el-input__inner,
      .el-input__inner {
        border-radius: 0px 4px 4px 0px;
      }
    }
  }
  .el-form-item {
    .el-date-editor {
      width: 100%;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
